module.exports = __webpack_public_path__ + "fonts/gaxon.36251c7b.woff";